import { render, staticRenderFns } from "./AfishaStartSection.vue?vue&type=template&id=5ceb0edc&scoped=true&"
import script from "./AfishaStartSection.vue?vue&type=script&lang=js&"
export * from "./AfishaStartSection.vue?vue&type=script&lang=js&"
import style0 from "./AfishaStartSection.vue?vue&type=style&index=0&id=5ceb0edc&scoped=true&lang=scss&"
import style1 from "./AfishaStartSection.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ceb0edc",
  null
  
)

export default component.exports